// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".datetime-select .v-input[data-v-66644cfc]{width:33.3333333333%;max-width:33.3333333333%}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/large_process/components/LargeProcessValueForm.vue"],"names":[],"mappings":"AAEC,2CACC,oBAAA,CACA,wBAAA","file":"LargeProcessValueForm.vue","sourcesContent":["\n.datetime-select {\n\t.v-input {\n\t\twidth: calc(100% / 3);\n\t\tmax-width: calc(100% / 3);\n\t}\n}\n"]}]);
// Exports
module.exports = exports;
